import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  id: "boiler-installation",
  title: "Boiler Installation & Replacement",
  description: "RGI-registered gas boiler installation and replacement across Dublin, with suitable system options and a clear written quotation before work begins.",
  buttonText: "View Boiler Installation",
  link: "/BoilerInstallationDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/professional_boiler_installation_dublin.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/professional_boiler_installation_dublin.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/professional_boiler_installation_dublin.webp-wvc-sizes",
  alt: "RGI registered engineer completing a gas boiler installation in Dublin",
  isHeatPumpInstall: false
}, {
  id: "boiler-repair",
  title: "Boiler Repair",
  description: "No heating, no hot water, unusual noises or a boiler fault code? We diagnose boiler problems and explain the available repair options clearly before work proceeds.",
  buttonText: "Boiler Repair",
  link: "/BoilerRepairDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_repair.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_repair.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_repair.png-wvc-sizes",
  alt: "Professional plumber completing a gas boiler repair in Dublin",
  isHeatPumpInstall: false
}, {
  id: "boiler-service",
  title: "Boiler Service",
  description: "Regular boiler servicing supports safe operation, dependable heating and early identification of developing faults. Book a professional boiler service at a suitable time.",
  buttonText: "Book a Boiler Service",
  link: "/BoilerServiceDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_service.png-wvc-sizes",
  alt: "Heating engineer performing safety checks during annual boiler service",
  isHeatPumpInstall: false
}, {
  id: "heat-pump-installation",
  title: "Heat Pump Installation",
  description: "We supply and install heat pump systems to improve efficiency and reduce home energy bills. Learn more about available ",
  buttonText: "Heat Pump Installation",
  link: "/HeatPumpInstallationDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/heat_pump_install.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/heat_pump_install.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/heat_pump_install.webp-wvc-sizes",
  alt: "Modern outdoor heat pump unit installed at a Dublin residence",
  isHeatPumpInstall: true
}, {
  id: "heat-pump-service",
  title: "Heat Pump Service",
  description: "Routine servicing can help maintain heat pump performance and identify operational problems. Contact us about scheduled maintenance or a system that is not heating as expected.",
  buttonText: "Book a Heat Pump Service",
  link: "/HeatPumpServiceDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/heat_pump_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/heat_pump_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/heat_pump_service.png-wvc-sizes",
  alt: "Technician conducting inspection and service on domestic heat pump system",
  isHeatPumpInstall: false
}, {
  id: "emergency-plumbing",
  title: "Emergency Plumbing",
  description: "For burst pipes, serious leaks and other urgent plumbing faults, call us to confirm the soonest available attendance. If safe to do so, shut off the water supply while waiting for assistance.",
  buttonText: "Call for Emergency Assistance",
  link: "/EmergencyPlumberDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/emergency_plumbing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/emergency_plumbing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/emergency_plumbing.png-wvc-sizes",
  alt: "Emergency plumber repairing a water leak with specialized tools",
  isHeatPumpInstall: false
}, {
  id: "general-plumbing",
  title: "General Plumbing",
  description: "We handle everyday plumbing faults and repairs, including leaking taps and pipes, toilets, cisterns, radiators, water-pressure issues and other general plumbing work.",
  buttonText: "General Plumbing Services",
  link: "/GeneralPlumbingDublinPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/general_plumbing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/general_plumbing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/general_plumbing.png-wvc-sizes",
  alt: "Plumber fitting copper pipework during general plumbing repair",
  isHeatPumpInstall: false
}];
export default function OurPlumbingHeatingServices() {
  return <section data-section-id="259936" id="our-plumbing-heating-services" className="relative min-h-[80vh] flex items-center justify-start overflow-hidden bg-background text-foreground py-20 md:py-28">
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/dublin_plumbing_specialist.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/dublin_plumbing_specialist.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/dublin_plumbing_specialist.png-wvc-sizes" alt="Professional plumber installing a modern boiler system in Dublin" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-primary/40 backdrop-blur-[2px]" />
      </div>

      <div className="container relative z-10 px-4 md:px-6">
        <div className="max-w-4xl space-y-6 mb-12">
          <h2 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold uppercase tracking-tighter text-white font-default leading-[1.1]">
            Plumbing and Heating Services
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl font-default">
            From urgent plumbing faults to planned heating maintenance, we provide practical, professional services for homes and properties throughout Dublin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-4">
          {services.map((service, i) => <div key={service.id} data-index={i} className="group relative flex flex-col justify-between overflow-hidden rounded-lg border border-white/20 bg-card/20 backdrop-blur-md p-6 shadow-lg hover:border-white/50 transition-all duration-300">
              <div>
                <div className="relative h-48 w-full overflow-hidden rounded-lg mb-4">
                  <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                </div>

                <div className="space-y-2 mb-6">
                  <h3 className="text-xl font-bold text-white group-hover:text-accent transition-colors">
                    <Link to={service.link}>
                      {service.title}
                    </Link>
                  </h3>
                  {service.isHeatPumpInstall ? <div>
                      <p className="text-sm text-white/80 font-default leading-relaxed">
                        We supply and install heat pump systems to improve efficiency and reduce home energy bills. Learn more about available{" "}
                        <Link to="https://www.seai.ie/grants/home-energy-grants/individual-grants/heat-pump-systems" newTab className="underline font-medium hover:text-accent transition-colors">
                          SEAI grants
                        </Link>
                        .
                      </p>
                      <p className="text-xs text-white/60 font-default mt-2">
                        Grant eligibility and payment are determined by SEAI. Terms and grant values may change.
                      </p>
                    </div> : <p className="text-sm text-white/80 font-default leading-relaxed">
                      {service.description}
                    </p>}
                </div>
              </div>

              <Button asChild size="sm" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-all justify-between">
                <Link to={service.link}>
                  <span>{service.buttonText}</span>
                  <ArrowRight className="size-4 ml-2" />
                </Link>
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}